import React, { useEffect, Suspense, lazy } from 'react';
import { MessageCircle } from 'lucide-react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { initFBPixel, trackViewContent } from './utils/fbPixel';
const VideoSection = lazy(() => import('./components/VideoSection').then(m => ({
  default: m.VideoSection
})));
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const SolutionIntro = lazy(() => import('./components/SolutionIntro').then(m => ({
  default: m.SolutionIntro
})));
const ProductsDetail = lazy(() => import('./components/ProductsDetail').then(m => ({
  default: m.ProductsDetail
})));
const PackagesSection = lazy(() => import('./components/PackagesSection').then(m => ({
  default: m.PackagesSection
})));
const CertificationsBar = lazy(() => import('./components/CertificationsBar').then(m => ({
  default: m.CertificationsBar
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const HowItWorks = lazy(() => import('./components/HowItWorks').then(m => ({
  default: m.HowItWorks
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  useEffect(() => {
    initFBPixel();
    trackViewContent();
  }, []);
  return <div className="min-h-screen bg-[#FAFAF7] font-sans text-[#1A1A1A]" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Suspense fallback={<div className="min-h-[200px]" data-id="element-5" />} data-id="element-4">
          <VideoSection data-id="element-6" />
          <PainPoints data-id="element-7" />
          <SolutionIntro data-id="element-8" />
          <ProductsDetail data-id="element-9" />
          <PackagesSection data-id="element-10" />
          <CertificationsBar data-id="element-11" />
          <Testimonials data-id="element-12" />
          <HowItWorks data-id="element-13" />
          <Guarantee data-id="element-14" />
          <FAQ data-id="element-15" />
          <FinalCTA data-id="element-16" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-17">
        <Footer data-id="element-18" />
      </Suspense>

      {/* Floating WhatsApp Button */}
      <a href="https://wa.link/zcnuqo" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 flex items-center justify-center" aria-label="Contact us on WhatsApp" data-id="element-19">
        <MessageCircle size={32} data-id="element-20" />
      </a>
    </div>;
}